// extracted by mini-css-extract-plugin
export default {"container":"Yn-z","disabled":"Zn-z","subtotal":"_n-z","legal":"ao-z"};